import React, { useState,useRef } from "react";
import { FieldArray, Form, Formik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { openSnackbar } from "../../../../Redux/Actions/snackbarActions";
import SalesReturnService from "../../../../Service/Invoice/SalesReturn.service";
import invoiceService from "../../../../Service/Invoice/invoice.service";
import FormControl from "../../../MUI_components/FormControl/fomikFormControl";
import customerService from "../../../../Service/Customer/customer.service";
import Steper from "../../../MUI_components/stepper";
import AsynchronousDropdown from "../../../MUI_components/AutoComplete/asynchronousAutoComplete";
import Print from "../Receipt/salesReturnBill/WithoutBill/WoDot"
import PosPrint from "../Receipt/salesReturnBill/WithoutBill/WoPos"
import itemMasterService from "../../../../Service/Item-master/itemMaster.service";

import { NumFormat } from "Components/MUI_components/currencyFormat";
import {
  Button,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import Selects from "Components/MUI_components/AutoComplete/selects";
import { SALES_RETURN_TYPE } from "Components/Constants/SalesReturnType";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";
import { useReactToPrint } from "react-to-print";
import { pageStyle } from "Components/Print/printPagesStyles";
import BasicDialog from "Components/MUI_components/Dialog-Box/basicDialog";
import Loading from "Components/MUI_components/loading";
import { currency } from "Components/MUI_components/currencyFormatterTag";

export default function ReturnWithoutBill(props) {
  const { setOpen,setSubmitted  } = props;
  const dispatch = useDispatch();
  const stockLocations = useSelector((state) => state.location);
  const defaultLocationSelected = useSelector((state) => state.defaultLocation);
  const location = localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION_NAME);
  const [disabledForSingle, setDisabledForSingle] = useState(false);
  const [returnData, setReturnData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [printType,setPrintType] = useState("pos")
  const initReturn = {
    customer: "",
    returnData: [],
    code: "",
    remarks: "",
    paidStatus: 0,
    itemMaster: null,
    quantity: "",
    totalAmount: "",
    locationCode: "",
    costPrice: "",
    retailPrice: "",
    wholesalePrice: "",
    batch: ""
  };

  const validation = yup.object({
    customer: yup.object().required("Customer is required"),
    returnData: yup.array().required(),
  });

  const [activeStep, setActiveStep] = React.useState(0);
  const [submitting, setSubmitting] = React.useState(false);
  const [stock, setStock] = useState(initReturn);
  const [openBillPrint, setOpenBillPrint] = useState(false);
  const [openPosPrint,setOpenPosPrint] = useState(false);
  const [returnValues, setReturnValues] = useState("");
  const computerReceiptPrintComponent = React.useRef(null);
  const billReceiptPrintComponent = React.useRef(null);
  const getSteps = ["Return without bill", "Returned items"];
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handlePrintPOS = useReactToPrint({

    content: () => billReceiptPrintComponent.current,
    onAfterPrint: () => {
      setOpenBillPrint(true);
      setOpen(false);
    },
    pageStyle: pageStyle.receipt,
  });

  const handlePrintDotMatrix = useReactToPrint({
    content: () => computerReceiptPrintComponent.current,
    onAfterPrint: (values) => {
      setOpenBillPrint(true);
      setOpen(false);

    },
    pageStyle: pageStyle.a4,
  });

  const printTypeRef = useRef("pos");


  const handlePrint = () => {
    if (printTypeRef.current === "dot") {
      handlePrintDotMatrix();
    } else {
      handlePrintPOS();
    }
  }
  const handleSubmit = async (values) => {
    setSubmitting(true);

    try {
      let totalAmount = values.returnData
        .map((data) => data.totalAmount)
        .reduce((totalAmount, i) => totalAmount + i, 0);

      const res = await SalesReturnService.create({
        ...values,
        totalAmount: totalAmount
      });

      setReturnData(res.submittedData);
      handlePrint();
      setSubmitted && setSubmitted((prev) => !prev);

      dispatch(
        openSnackbar(true, "success", `Sales return added successfully`)
      );
      setOpen(false);
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
    setSubmitting(false);
  };




  return (

    <Grid container justify="center">
      <Grid item lg={12} sm={12} xs={12}>
        <Formik
          initialValues={initReturn}
          validationSchema={validation}
          onSubmit={async (values) => {
            let val = {
              ...values,
              totalAmount: initReturn.totalAmount,
              locationCode: defaultLocationSelected.location.code,
              customerCode: values.customer.code,
              returnType: SALES_RETURN_TYPE.SALES_RETURN_WITHOUT_BILL
            }
            if (activeStep === getSteps.length - 1) {
              setOpenBillPrint(true);
              setReturnValues(val);
            } else handleNext();

          }}
        >
          {(props) => {
            const { isSubmitting } = props;
            return (
              <Form autoComplete="off">
                <Steper
                  getSteps={getSteps}
                  StepContent={getStepContent}
                  activeStep={activeStep}
                  values={props.values}
                  setFieldValue={props.setFieldValue}
                />
                <div className="flex space-between mb">
                  <Button
                    disabled={activeStep === 0 || props.isValid === false}
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                  <div style={{ display: "flex" }}>
                    <Button
                      disabled={
                        submitting ||
                          (!props.values.returnData.length &&
                            activeStep === getSteps.length - 1)
                          ? true
                          : false
                      }
                      startIcon={
                        submitting && (
                          <CircularProgress color="inherit" size={20} />
                        )
                      }
                      variant="contained"
                      type="submit"
                      color="secondary"

                    >
                      {activeStep === getSteps.length - 1 ? "Complete" : "Next"}
                    </Button>
                    <BasicDialog
                      title="Sales Return Without Bill"
                      open={openBillPrint}
                      onClose={(e) => setOpenBillPrint(false)}
                    >
                      <div className="flex">
                        <button
                          disabled={disabledForSingle}
                          type="submit"
                          className="btn-success button"
                          onClick={() => {
                            handleSubmit(returnValues);
                            printTypeRef.current = "pos";
                          }}
                        >
                          pos bill
                          <span>
                            {isSubmitting ? (
                              <CircularProgress
                                color="inherit"
                                size={20}
                              />
                            ) : (
                              "[ Enter ]"
                            )}
                          </span>
                        </button>

                        <button
                          type="submit"
                          disabled={disabledForSingle}
                          onClick={() => {
                            handleSubmit(returnValues);
                            printTypeRef.current = "dot";
                          }}
                          className="btn-success button"
                        >
                          Dot matrix bill
                          <span>
                            {isSubmitting ? (
                              <CircularProgress
                                color="inherit"
                                size={20}
                              />
                            ) : (
                              ""
                            )}
                          </span>
                        </button>

                      </div>
                      <div className="flex-end">
                        <Button
                          color="secondary"
                          onClick={() => {
                            setOpenBillPrint(false)
                          }}
                        >
                          Close
                        </Button>
                      </div>
                    </BasicDialog>


                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Grid>
    </Grid>
  );
  function getStepContent(step, values, setFieldValue) {



    switch (step) {
      case 0:
        return (
          <div className="flex mt">
            <div className="col-4">
              <FormControl
                control="asynchronousAutoComplete"
                label="Customer"
                name="customer"
                Service={customerService}
                getOptionLabel={(option) =>
                  option.firstName + "-" +
                  option.phone1  + "-" +
                  option.code
                }
              />
            </div>
            <div className="col-7">
              <FormControl label="Remarks" name="remark" control="input" />
            </div>
          </div>
        );
      case 1:
        return (
          <FieldArray name="returnData">
            {(returnDataProps) => (
              <>
                <div className="row">
                  <div className="col-7">
                    <AsynchronousDropdown
                      inputProps={{
                        label: "Item Master",
                      }}
                      disabled={stock.editIndex || stock.editIndex === 0}
                      withoutLocationFilter
                      name="itemMaster"
                      Service={itemMasterService.search}
                      value={stock.itemMaster}
                      onChange={(e, newValue) =>
                        newValue === null
                          ? setStock({
                            ...stock,
                            itemMaster: null,
                            costPrice: "",
                            retailPrice: "",
                            wholesalePrice: "",
                          })
                          : setStock({
                            ...stock,
                            itemMaster: newValue,
                            costPrice: newValue.costPrice,
                            retailPrice: newValue.retailPrice,
                            wholesalePrice: newValue.wholesalePrice,

                          })
                      }
                      getOptionLabel={(option) =>
                        option.name +
                        " - " +
                        option.barcode
                      }
                    />
                  </div>
                  <div className="col-5">
                    <Selects
                      disabled
                      label="Stock Location*"
                      options={stockLocations}
                      name="locationCode"
                      // value={stock.locationCode}
                      value={defaultLocationSelected.location.code}
                    />
                  </div>

                </div>
                <div className="row">

                  <div className="col-6">
                    <FormControl
                      fullWidth
                      label="Quantity"
                      control="number"
                      name="quantity"
                    />
                  </div>
                  <div className="col-6">
                    <FormControl
                      name="retailPrice"
                      label="Retail Price*"
                      control="currency"
                      onValueChange={(val) =>
                        setStock({
                          ...stock,
                          retailPrice: val.floatValue
                        })
                      }
                      value={stock.retailPrice}

                    />
                  </div>
                </div>

                <div className="flex flex-end mb">
                  <Button
                    variant="contained"
                    type="button"
                    disabled={!stock.itemMaster || !values.quantity || !stock.retailPrice}
                    color="primary"
                    onClick={() => {
                      const qty = values.quantity ? values.quantity : 1;
                      returnDataProps.push({
                        itemMaster: stock.itemMaster,
                        itemCode: stock.itemMaster.code,
                        customerCode: values.customer.code,
                        locationCode: defaultLocationSelected.location.code,
                        quantity: qty,
                        costPrice: stock.costPrice,
                        retailPrice: stock.retailPrice,
                        totalAmount: stock.retailPrice * qty,
                        batch: values.batch
                      });
                      setStock(initReturn);
                      setFieldValue("quantity", "");
                    }}
                  >
                    Add
                  </Button>
                </div>
                <div className="flex mt mb">
                  <TableContainer>
                    <Table size="small" aria-label="spanning table">
                      <TableHead style={{ backgroundColor: "#cacaca50" }}>
                        <TableRow>
                          <TableCell align="center" colSpan={4}>
                            Details
                          </TableCell>
                          <TableCell align="right">{COLUMNS_NAME.AMOUNT}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell width="5"></TableCell>
                          <TableCell>{COLUMNS_NAME.DESCRIPTION}</TableCell>
                          <TableCell align="right">{COLUMNS_NAME.QUANTITY}</TableCell>
                          <TableCell align="right">{COLUMNS_NAME.RETAIL_PRICE}</TableCell>
                          <TableCell align="right">{COLUMNS_NAME.TOTAL}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {values.returnData.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell width="5">
                              <Delete
                                color="secondary"
                                style={{
                                  fontSize: 18,
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      "Are you sure want to delete this?"
                                    )
                                  )
                                    returnDataProps.remove(index);
                                }}
                              />
                            </TableCell>
                            <TableCell>{row.itemMaster["name"]}</TableCell>
                            <TableCell align="right">
                              <FormControl
                                control="customInput"
                                name={`returnData[${index}].quantity`}
                              />
                            </TableCell>
                            <TableCell align="right">
                              <FormControl
                                control="customInput"
                                name={`returnData[${index}].retailPrice`}
                              />
                            </TableCell>
                            <TableCell align="right">
                              {currency(row.quantity * row.retailPrice)}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableHead>
                        {values.returnData.length === 0 ? (
                          <TableRow>
                            <TableCell align="center" colSpan={7}>
                              No Data
                            </TableCell>
                          </TableRow>
                        ) : (
                          <>
                            <TableRow>
                              <TableCell colSpan={3} />
                              <TableCell align="right">
                                <strong>{COLUMNS_NAME.TOTAL}</strong>
                              </TableCell>
                              <TableCell align="right">
                                <strong>{currency(values.returnData
                                  .map((data) => data.retailPrice * data.quantity)
                                  .reduce((totalAmount, i) => totalAmount + i, 0))}</strong>
                              </TableCell>
                            </TableRow>
                          </>
                        )}
                      </TableHead>
                    </Table>
                  </TableContainer>
                </div>
                <div style={{ display: "none" }}>
                  {returnData.code && <><Print
                    ref={computerReceiptPrintComponent}
                    returnData={returnData} /></>}

                  {returnData.code && <><PosPrint
                    ref={billReceiptPrintComponent}
                    returnData={returnData} /></>}
                </div>
              </>
            )}
          </FieldArray>
        );
      default:
        return null;
    }

  }

}